import React, { useState, useEffect } from 'react';
import { Card, Row, Col, message, Button, Modal, Descriptions, Image, Space } from 'antd';
import Data from '../../CustomText/data';
import { formatDate } from '../../../helpers/genericHelper';
import API from '../../../services/API';
import LoaderComponent from "../../Loader";
import { isSupportLead } from '../../../helpers/genericHelper';

const DocumentVerifications = ({ userId }) => {
  const [documentVerifications, setDocumentVerifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [detailedResult, setDetailedResult] = useState(null);
  const [images, setImages] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [rotationFront, setRotationFront] = useState(0);
  const [rotationBack, setRotationBack] = useState(0);
  const [rotationSelfie, setRotationSelfie] = useState(0);


  const getDocumentVerifications = async (userId) => {
    try {
      setLoading(true)
      const result = await API.getDocumentVerifications(userId);
      setDocumentVerifications(result);
    } catch (error) {
      message.error("Unable to fetch document verifications")
      console.error("Unable to fetch document verifications", error)
    } finally {
      setLoading(false);
    }
  }

  const fetchDetails = async verificationId => {
    setModalVisible(true);
    setDetailLoading(true);

    const pResult = API.getDocumentVerificationResult({ userId, id: verificationId })
      .then(setDetailedResult)
      .catch(err => {
        message.error('Failed to fetch verification result');
        console.error('Failed to fetch verification result', err);
      });

    const pImages = API.getDocumentVerificationImages({ userId, id: verificationId })
      .then(setImages)
      .catch(err => {
        message.error('Failed to fetch images');
        console.error('Failed to fetch images', err);
      });

    await Promise.all([pResult, pImages]);
    setDetailLoading(false);
  };

  useEffect(() => {
    if (userId) {
      getDocumentVerifications(userId);
    }
  }, [userId]);

  if (loading) {
    return <LoaderComponent />;
  }

  return (
    <>
      {documentVerifications && documentVerifications.length > 0 ? documentVerifications.map((verification) => (
        <Card bordered={false} className="criclebox tablespace mb-16" key={verification.id}>
          <Row className="subscription-cancelled-card" gutter={[16, 16]}>
            <Col xs={12} sm={8} md={6} xl={4}>
              <Data title="ID" value={verification.id} />
            </Col>
            <Col xs={6} sm={5} md={3} xl={2}>
              <Data title="Status" value={verification.status} />
            </Col>
            <Col xs={8} sm={6} md={4} xl={3}>
              <a href={verification.url} style={{marginTop: "1.4em", display: "inline-block"}}>Verification URL</a>
            </Col>
            <Col xs={8} sm={6} md={4} xl={3}>
              <Data title="Expires" value={formatDate(verification.expires, true)} />
            </Col>
            <Col xs={8} sm={6} md={4} xl={3}>
              <Data title="Context" value={verification.context} />
            </Col>
            <Col xs={8} sm={6} md={4} xl={3}>
              <Data title="Email" value={verification.requestEmail?.value || 'N/A'} />
            </Col>
            <Col xs={8} sm={6} md={4} xl={3}>
              <Data title="Zendesk Ticket" value={verification.zendeskTicket || 'N/A'} />
            </Col>
            <Col xs={8} sm={6} md={4} xl={3}>
              <Button onClick={() => fetchDetails(verification.id)}>View Details</Button>
            </Col>
          </Row>
        </Card>
      )) : (
        <Row className="no-data-card">No Data Found</Row>
      )}
      <Modal
        title="Document Verification Details"
        open={modalVisible}
        onCancel={() => {setModalVisible(false); setImages(null); setDetailedResult(null)}}
        width={900}
        destroyOnClose={true}
      >
        {detailedResult && (
          <div>
            <Descriptions title="General" bordered column={1} style={{ marginBottom: 16 }}>
              <Descriptions.Item label="Verification ID">{detailedResult.verificationId || 'N/A'}</Descriptions.Item>
              <Descriptions.Item label="Status">{detailedResult.status || 'N/A'}</Descriptions.Item>
            </Descriptions>
            <Descriptions title="Document Data" bordered column={1} style={{ marginBottom: 16 }}>
              {detailedResult.documentData ? <>
                <Descriptions.Item label="Type">{detailedResult.documentData?.type || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Number">{detailedResult.documentData?.number || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Date of Birth">{detailedResult.documentData?.dateOfBirth || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Date of Issue">{detailedResult.documentData?.dateOfIssue || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Date of Expiry">{detailedResult.documentData?.dateOfExpiry || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Issuing Country">{detailedResult.documentData?.issuingCountry || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Issuing Region Code">{detailedResult.documentData?.issuingRegionCode || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="First Name">{detailedResult.documentData?.firstName || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Middle Name">{detailedResult.documentData?.middleName || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Last Name">{detailedResult.documentData?.lastName || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Address">{detailedResult.documentData?.address || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Gender">{detailedResult.documentData?.gender || 'N/A'}</Descriptions.Item>
                </>
              : <p>No Document data found</p>
            }
            </Descriptions>

            
            <Descriptions title="Verification Levels" bordered column={1}>
              {detailedResult.verification ? <>
                <Descriptions.Item label="Risk Level">{detailedResult.verification?.riskLevel || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Forgery Level">{detailedResult.verification?.forgeryLevel || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Document Match Level">{detailedResult.verification?.documentMatchLevel || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Image Quality Level">{detailedResult.verification?.imageQualityLevel || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Face Match Level">{detailedResult.verification?.faceMatchLevel || 'N/A'}</Descriptions.Item>
              </>
            : <p>No verification levels found</p>
            }</Descriptions>

          </div>

        )}
        {images && (
          <>
            <h3>Images</h3>
            {images.front && (
              <>
                <h4>Front</h4>
                <Button onClick={() => setRotationFront(rotationFront - 90)} style={{ marginBottom: 8, zIndex: 100, display: "block" }}>Rotate</Button>
                <Image
                  src={`data:image/jpeg;base64,${images.front}`}
                  alt="Front"
                  style={{maxWidth: '850px', maxHeight: "850px", rotate: `${rotationFront}deg`}}
                  onContextMenu={(e) => e.preventDefault()}
                  preview={false}
                />
              </>
            )}
            {images.back && (
              <>
                <h4>Back</h4>
                <Button onClick={() => setRotationBack(rotationBack - 90)} style={{ marginBottom: 8, zIndex: 100, display: "block" }}>Rotate</Button>
                <Image
                  src={`data:image/jpeg;base64,${images.back}`}
                  alt="Back"
                  style={{ maxWidth: '850px', maxHeight: "850px", rotate: `${rotationBack}deg`}}
                  onContextMenu={(e) => e.preventDefault()}
                  preview={false}
                />
              </>
            )}
            {images.selfie && (
              <>
                <h4>Selfie</h4>
                <Button onClick={() => setRotationSelfie(rotationSelfie - 90)} style={{ marginBottom: 8, zIndex: 100, display: "block" }}>Rotate</Button>
                <Image
                  src={`data:image/jpeg;base64,${images.selfie}`}
                  alt="Selfie"
                  style={{ maxWidth: '850px', maxHeight: "850px", rotate: `${rotationSelfie}deg`}}
                  onContextMenu={(e) => e.preventDefault()}
                  preview={false}
                />
              </>
            )}
          </>
        )}

        {!detailLoading && !images?.selfie && !images?.front && !images?.back &&
        <p style={{marginTop: "2em", textAlign: "center"}}>No images found</p>}

        {detailLoading && <LoaderComponent/>}
      </Modal>
    </>
  );
};

export default DocumentVerifications;